import { useAppDispatch, useAppSelector } from 'store'
import {
  Context,
  Environment,
  sdk as squareSdk,
  SDKActionCallbacks,
} from '@squareup/sq-addons-web-sdk'
import { CONTEXT, CUSTOMER, ORDER } from 'local-host-data'
import { setContext } from 'reducers/pos'
import { err, ok, Result } from 'utils/result'
import { useCallback } from 'react'
import { buildTranslate } from 'locales'

const t = buildTranslate('general')

export function usePosContext() {
  return useAppSelector(state => state.pos.context)
}

export function usePointsCurrencyName(balance: number): string {
  const posContext = usePosContext()

  const kind = balance === 1 ? 'pointsCurrencySingular' : 'pointsCurrencyPlural'
  const value = posContext?.configurations?.[kind] as string | undefined

  return value ?? t(kind)
}

export function useInitSdk() {
  const dispatch = useAppDispatch()

  const initializeSdk = useCallback(
    async (callbacks: SDKActionCallbacks): Promise<Result<Context, Error>> => {
      try {
        const sdkEnv = process.env.SQ_ADDONS_SDK_ENVIRONMENT as string
        const context = await squareSdk.initialize(callbacks, {
          environment:
            sdkEnv === 'LOCALHOST' ? Environment.LOCAL_HOST : Environment.POS,
          localHostData: {
            context: CONTEXT,
            order: ORDER,
            customer: CUSTOMER,
          },
        })
        dispatch(setContext(context))
        return ok(context)
      } catch (error) {
        return err(error as Error)
      }
    },
    [dispatch]
  )

  return {
    initializeSdk,
  }
}
